import React from 'react'
import type { JSX } from 'react'

export function ModalImage({
  alt,
  src,
  loading = 'lazy',
  ...imgHTMLAttributes
}: Omit<
  JSX.IntrinsicElements['img'],
  // Omitted because required:
  | 'alt'
  | 'src'
  // Omitted because not allowed:
  | 'className'
> &
  Required<Pick<JSX.IntrinsicElements['img'], 'alt' | 'src'>>) {
  return (
    <img
      alt={alt}
      className={'mt-2.5 mb-5 mx-auto'}
      height={104}
      loading={loading}
      src={src}
      width={104}
      {...imgHTMLAttributes}
    />
  )
}
